import { useNavigate } from "react-router-dom";
import { ReactComponent as SkedyLogo } from "../../static/images/logo.svg";
import "./style.scss";

const MainHeader = () => {
  const navigate = useNavigate();

  const goToHomePage = () => {
    navigate("/");
  };

  return (
    <div className="main-header" onClick={goToHomePage}>
      <SkedyLogo />
    </div>
  );
};

export default MainHeader;
